module.exports = __webpack_public_path__ + "static/media/Side Road - Instrumental Version.26bcd9b8.jpg";